export const commitNumberInput = (rawValue, min, max, currentValue, setValue, setInput) => {
	const parsedValue = parseInt(rawValue, 10);

	if (Number.isNaN(parsedValue)) {
		setInput(currentValue.toString());
		return;
	}

	const clampedValue = clamp(parsedValue, min, max);
	setValue(clampedValue);
	setInput(clampedValue.toString());
};

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export const handleArrowCommit = (event, min, max, currentValue, setValue, setInput) => {
	if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
		commitNumberInput(event.target.value, min, max, currentValue, setValue, setInput);
	}
};

export const handleRangeIntChange = (event, setValue, setInput = () => {}) => {
	const nextValue = parseInt(event.target.value, 10);
	setValue(nextValue);
	setInput(nextValue.toString());
}